import {
    FURUI_GET_FRUI_PLAN_LIST_BEGIN,
    FURUI_GET_FRUI_PLAN_LIST_SUCCESS,
    FURUI_GET_FRUI_PLAN_LIST_FAILURE,
    FURUI_GET_FRUI_PLAN_LIST_DISMISS_ERROR,
  } from './constants';
  
  import request from '../../../utils/request'
  // Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
  // If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
  export function getFrui_planList(params) {
    return (dispatch) => { // optionally you can have getState as the second argument
      dispatch({
        type: FURUI_GET_FRUI_PLAN_LIST_BEGIN,
      });
     params.size = 10;

     const promise = new Promise((resolve, reject) => {
          request({
            method:'post',
            url:'/api/b/frui_plan/list',
            data:params,
          }).then( data => {
              dispatch({
                  type: FURUI_GET_FRUI_PLAN_LIST_SUCCESS,
                  data: Object.assign({},data,{page:params.page}),
              });
              resolve(data);
          }).catch (error => {
              dispatch({
                type: FURUI_GET_FRUI_PLAN_LIST_FAILURE,
                data: { error: error },
              });
              reject(error);
          })
      });
  
      return promise;
    };
  }
  
  // Async action saves request error by default, this method is used to dismiss the error info.
  // If you don't want errors to be saved in Redux store, just ignore this method.
  export function dismissGetFrui_planListError() {
    return {
      type: FURUI_GET_FRUI_PLAN_LIST_DISMISS_ERROR,
    };
  }
  
  export function reducer(state, action) {
    switch (action.type) {
      case FURUI_GET_FRUI_PLAN_LIST_BEGIN:
        // Just after a request is sent
        return {
          ...state,
          getFrui_planListPending: true,
          getFrui_planListError: null,
        };
  
      case FURUI_GET_FRUI_PLAN_LIST_SUCCESS:
        // The request is success
  
        const byId = {};
        const items = [];
        action.data.list.forEach(item => {
          items.push(item.id);
          byId[item.id] = item;
        });
        return {
          ...state,
          frui_planById:byId,
          frui_planList:items,
          frui_planPage: action.data.page,
          frui_planSize: action.data.size,
          frui_planTotal: action.data.count,
          getFrui_planListPending: false,
          getFrui_planListError: null,
        };
  
      case FURUI_GET_FRUI_PLAN_LIST_FAILURE:
        // The request is failed
        return {
          ...state,
          getFrui_planListPending: false,
          getFrui_planListError: action.data.error,
        };
  
      case FURUI_GET_FRUI_PLAN_LIST_DISMISS_ERROR:
        // Dismiss the request failure error
        return {
          ...state,
          getFrui_planListError: null,
        };
  
      default:
        return state;
    }
  }


// WEBPACK FOOTER //
// ./src/features/furui/redux/getFrui_planList.js